import * as React from 'react';
import useTranslation from 'next-translate/useTranslation';
import styles from './FilterBadges.module.scss';
import type * as Types from '@/pages/mijn-carel-lurvink/catalogus/stores/types';

export interface IBadge {
  code: Types.TypeClass;
  value: Types.TypeClass;
  urlSet: Types.URLSet;
  rel?: any;
}

export interface IFilterBadges {
  items: IBadge[];
  phrases: any; // These should not live on props
  onFilterBadgeClick: (arg0: IBadge) => void;
}

export const FilterBadges = ({ items, onFilterBadgeClick }: IFilterBadges) => {
  const { t } = useTranslation('search');
  if (!items || items.length === 0) {
    return null;
  }

  const handleBadgeClick = async (e: React.MouseEvent<HTMLButtonElement>, badge: IBadge) => {
    e.preventDefault();
    onFilterBadgeClick(badge);
  };

  return (
    <div className={styles.FilterBadgeList}>
      <span className="text-color-basic text-nowrap mb-1 mr-2">{t('search:active-filters')}</span>
      {items.map((badge: IBadge) => {
        return (
          <div className={styles.FilterBadge} key={`${badge.code.code}:${badge.value.code}`}>
            <button
              className="badge btn bg-theme-2 text-white mr-2"
              role="button"
              rel={badge.rel}
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleBadgeClick(e, badge)}
            >
              <span className={styles.code}>{badge.code.value}: </span>
              <span className={styles.value}>{badge.value.value}</span>
              <span className="fa fa-times ml-2"></span>
            </button>
          </div>
        );
      })}
    </div>
  );
};
